import { ExersiseTypes } from "@l_learn/shared";
import type React from "react";

// Helper component to render the exercise content (text and gaps)
export const ExerciseContent = ({
	text,
	gapComponent,
	renderGap
}: {
	text: ExersiseTypes.ExerciseContent;
	gapComponent?: React.ReactNode;
	renderGap?: (index: number) => React.ReactNode;
}) => {
	let gapIndex = 0;

	return (
		<p className="text-lg leading-11">
			{text.map((content, index) => {
				if (content.type === ExersiseTypes.Content.String) {
					return <span key={index}>{(content as ExersiseTypes.StringContent).text}</span>;
				}
				if (content.type === ExersiseTypes.Content.FillGap) {
					const currentGapIndex = gapIndex++;
					return (
						<span key={index}>
							{renderGap ? renderGap(currentGapIndex) : gapComponent}
						</span>
					);
				}
				return null;
			})}
		</p>
	);
};
